import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ORGANIZATION_FEATURE_KEY,
  OrganizationState,
  organizationAdapter
} from './organization.reducer';

// Lookup the 'Organization' feature state managed by NgRx
export const getOrganizationState = createFeatureSelector<OrganizationState>(ORGANIZATION_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } = organizationAdapter.getSelectors();

export const getOrganizationIdError = createSelector(
  getOrganizationState,
  (state: OrganizationState) => state.organizationIdLoadError
);


export const getCurrentOrganizationId = createSelector(
  getOrganizationState,
  (state: OrganizationState) => state.currentOrganizationId
)


export const getCurrentOrganization = createSelector(
  getOrganizationState,
  (state: OrganizationState) => state.currentOrganization
)




export const listenForOrganizationFireStoreError = createSelector(
  getOrganizationState,
  (state: OrganizationState) => state.firestoreOrganizationError
);



export const listenForOrganizationUpdateError = createSelector(
  getOrganizationState,
  (state: OrganizationState) => state.updateOrganizationError
);

export const listenForOrganizationUpdateSuccess = createSelector(
  getOrganizationState,
  (state: OrganizationState) => state.updateOrganizationSuccess
);








